export const hasFeature = (company, feature) =>
  company?.features?.includes(feature);
